import { Component, OnInit } from '@angular/core';
import { ToastrService } from "ngx-toastr";
import { Router } from '@angular/router';
import { UserManagementService } from "../../services/user-management.service";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Validators, FormControl } from '@angular/forms'

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  public email: string;
  public error: boolean;
  public required: boolean;
  public emailAddress: FormControl;
  public errorMessage: string;
  public submitted = false;

  constructor(
    private _userManagementService: UserManagementService,
    private _router: Router,
    private _toastService: ToastrService,
    private _ngxUiLoaderService: NgxUiLoaderService) {
  }

  public async ngOnInit(): Promise<void> {
    this.emailAddress = new FormControl('', Validators.compose([Validators.required]));
  }

  public async forgotPassword(): Promise<void> {
    this.submitted = true;
    if (this.emailAddress.status == "INVALID") {
      this.required = true;
      return;
    }
    this.required = false;
    this._ngxUiLoaderService.start();
    const submitted = await this._userManagementService.ForgotPassword(this.email);
    if (submitted.success === true) {
      this._toastService.success(submitted.message, "Success");
      this._router.navigate(['account/login']);
    } else {
      //this._toastService.error(submitted.message, "Error");
      this.error = true;
      this.errorMessage = submitted.message;
    }

    this._ngxUiLoaderService.stop();
  }

  public goBack(): void {
    this.email = '';
    this._router.navigate(['account/login']);
  }

}
